<div class="page__content">
    <div class="content__inner">
        <div class="content__login">
            <div class="card__login">
                <form *ngIf="!isSuccessful" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
                    <h1>{{ 'FORGOT.TITLE' | translate }}</h1>

                    <div class="form-group">
                        <input type="email" class="form-control" name="email" [(ngModel)]="form.email" required email #email="ngModel" [placeholder]="'FORGOT.EMAIL_PH' | translate" />
                        <div class="alert-danger" *ngIf="email.errors && f.submitted">
                            <div *ngIf="email.errors['required']">{{ 'FORGOT.EMAIL_REQUIRED' | translate }}</div>
                            <div *ngIf="email.errors['email']">{{ 'FORGOT.EMAIL_INVALID' | translate }}</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary btn-block" [disabled]="loading">{{ 'FORGOT.SUBMIT' | translate }}</button>
                    </div>
                    <div class="form-group">
                        <a routerLink="../login" class="forgot-password">{{ 'FORGOT.CANCEL' | translate }}</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
